import React from 'react'
import Wrapper from './Wrapper'
import { Button } from 'components/base'
import { getRootURL } from 'helpers/URLHelper'

const GoToOrganizationSelectButton = (
  <Button.Primary href={`${getRootURL()}/organization/select`}>
    Go to team selection
  </Button.Primary>
)

export default function UnknownError() {
  return (
    <Wrapper goBackButton={GoToOrganizationSelectButton}>
      We cannot find your team
    </Wrapper>
  )
}
